import { Box, Stack, Typography } from "@mui/material";

interface Props {
	coverageFor: {
		options: string[];
		is_present: boolean;
		is_visible_in_form: boolean;
	};
}

const CoverageForCard = ({ coverageFor }: Props) => {
	if (!coverageFor?.is_present || !coverageFor.options?.length) {
		return (
			<Typography fontSize={15} color="text.secondary" lineHeight={1.4}>
				N/A
			</Typography>
		);
	}

	return (
		<Stack direction="row" flexWrap="wrap" gap={0.75}>
			{coverageFor.options.map((option, index) => (
				<Box
					key={index}
					sx={{
						px: 1.35,
						py: 0.5,
						borderRadius: 1,
						// border: "1px solid #e2e8f0",
						backgroundColor: "#f9fafb",
						fontSize: 14.5,
						fontWeight: 500,
						lineHeight: 1.35,
						color: "#111827",
						whiteSpace: "nowrap",
						boxShadow: "0 1px 1px rgba(0,0,0,0.05)"
					}}
				>
					{option}
				</Box>
			))}
		</Stack>
	);
};

export default CoverageForCard;
